import React, { Component } from 'react';
import PropTypes from 'prop-types';

import theme from './ReadMore.scss';

class ReadMore extends Component {

  static propTypes = {
    content: PropTypes.string.isRequired,
    maxCharAmount: PropTypes.number.isRequired,
    showText: PropTypes.shape({
      id: PropTypes.string.isRequired,
      defaultMessage: PropTypes.string,
    }).isRequired,
    hideText: PropTypes.shape({
      id: PropTypes.string.isRequired,
      defaultMessage: PropTypes.string,
    }).isRequired,
  };

  static defaultProps = {
  };

  state = {
    contentVisible: false,
  };

  showContent = () => {
    this.setState({
      contentVisible: true,
    });
  };

  hideContent = () => {
    this.setState({
      contentVisible: false,
    });
  };

  render() {
    const { content, maxCharAmount, showText, hideText } = this.props;

    return (
      <span>
        { content.length < maxCharAmount ?
          <span>{ content }</span> :
          <span>
            { content.substring(0, maxCharAmount) }
            { this.state.contentVisible ?
              <span>
                { content.substring(maxCharAmount) }
                <div
                  onClick={ this.hideContent }
                  className={ theme.hide }
                >
                  { hideText }
                </div>
              </span> :
              <div
                onClick={ this.showContent }
                className={ theme.show }
              >
                { showText }
              </div>
            }
          </span>
        }
      </span>
    );
  }
}

export default ReadMore;
